'use client'

import { ReactNode, useEffect } from 'react'
import { useWeb3Ready } from '@domain/auth/context/Web3ReadyContext'

/** Activates Web3 on fund routes without blocking server-rendered page shells. */
export default function FundLayout({ children }: { children: ReactNode }) {
  const web3Ready = useWeb3Ready()

  useEffect(() => {
    web3Ready?.activate()
  }, [web3Ready])

  return <>{children}</>
}
